import React from 'react';
import { DialogLightTheme } from 'qs-components/Common/LightThemeDialog';
import SettingsIframeComponent from 'qs-components/AccountSettings/CompanySettings/SettingsIframeComponent';
import { ReactComponent as CloseIcon } from 'qs-assets/Media/close.svg';
import './styles.scss';

const CreateOrderDialog = ({ open, onClose }) => {
  return (
    <DialogLightTheme
      open={open}
      onClose={onClose}
      title={''}
      className="create-order-dialog"
      onClick={event => {
        event.stopPropagation();
        event.preventDefault();
      }}
    >
      <div className="create-order-dialog-container">
        <div className="create-order-dialog-closeIconContainer" onClick={onClose}>
          <CloseIcon className="create-order-dialog-closeIcon" />
        </div>
        <SettingsIframeComponent
          id="create-order-dialog"
          title="Create order"
          route="create-order"
        />
      </div>
    </DialogLightTheme>
  );
};

export default CreateOrderDialog;
